import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'
import { DataMap } from '@grapecity/wijmo.grid'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, EquipmentGet, Grid, ListItem, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { EquipmentGetModalComponent } from './equipment-get-modal.component'
import { PartsFluidsEquipmentContext } from './parts-fluids-equipment-context'

@Component({
    selector: 'app-equipment-get-list',
    templateUrl: './equipment-get-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        RouterLink,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        AutoSizeDirective,
    ],
})
export class EquipmentGetListComponent extends BaseComponent implements OnChanges {
    @Input() canEdit = false
    @Input() equipmentOptions: ListItem<string>[] = []
    @Input() equipmentDataMap!: DataMap
    @Input() allItems: EquipmentGet[] = []
    @Input() parent!: PartsFluidsEquipmentContext

    grid: Grid<EquipmentGet>

    constructor() {
        super()
        this.grid = new Grid<EquipmentGet>(this.services, 'equipment', this)
            .setupModalEditing(
                this.services.data.equipmentGets,
                'GET',
                EquipmentGetModalComponent,
                () => {
                    const item = new EquipmentGet()
                    item.id = crypto.randomUUID()
                    return item
                },
                this,
                ModalSize.large,
            )
            .filterBy(item => [
                item.equipment,
                item.mainEdgePartNumber,
                item.sideCutPartNumber,
                item.boltPinPartNumber,
                item.nutPartNumber,
            ])
    }

    ngOnChanges() {
        this.grid.items = this.allItems
    }
}
